export * from './routed-label.module';
export * from './routed-label.component';
